import { createSlice } from "@reduxjs/toolkit";
import {
  getRoles,
  getRoleById,
  addNewRole,
  updateRole,
  deleteRole
} from './thunk';

export const initialState = {
  roles: [],
  selectedRole: null,
  isRoleSuccess: false,
  isRoleAdd: false,
  isRoleUpdate: false,
  isRoleDelete: false,
  error: {}
};

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    resetRoleFlags: (state) => {
      state.isRoleSuccess = false;
      state.isRoleAdd = false;
      state.isRoleUpdate = false;
      state.isRoleDelete = false;
      state.error = {};
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRoles.pending, (state) => {
      state.isRoleSuccess = false;
    });

    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.roles = Array.isArray(action.payload) ? action.payload : action.payload.data || [];
      state.isRoleSuccess = true;
      state.error = {};
    });

    builder.addCase(getRoles.rejected, (state, action) => {
      state.error = action.error || {};
      state.isRoleSuccess = false;
    });

    builder.addCase(getRoleById.fulfilled, (state, action) => {
      state.selectedRole = action.payload;
    });

    builder.addCase(getRoleById.rejected, (state, action) => {
      state.error = action.error || {};
    });

    builder.addCase(addNewRole.fulfilled, (state, action) => {
      const newRole = action.payload;
      state.roles.push(newRole);
      state.isRoleAdd = true;
      state.isRoleSuccess = true;
      state.error = {};
    });

    builder.addCase(addNewRole.rejected, (state, action) => {
      state.error = action.error || {};
      state.isRoleAdd = false;
    });

    builder.addCase(updateRole.fulfilled, (state, action) => {
      const updatedRole = action.payload;
      state.roles = state.roles.map(role =>
        role.id === updatedRole.id ? { ...role, ...updatedRole } : role
      );
      state.isRoleUpdate = true;
      state.isRoleSuccess = true;
      state.error = {};
    });

    builder.addCase(updateRole.rejected, (state, action) => {
      state.error = action.error || {};
      state.isRoleUpdate = false;
    });

    builder.addCase(deleteRole.fulfilled, (state, action) => {
      state.roles = state.roles.filter(role => role.id !== action.payload.id);
      state.isRoleDelete = true;
      state.isRoleSuccess = true;
      state.error = {};
    });

    builder.addCase(deleteRole.rejected, (state, action) => {
      state.error = action.error || {};
      state.isRoleDelete = false;
    });
  },
});

export const { resetRoleFlags, setSelectedRole } = rolesSlice.actions;

export default rolesSlice.reducer;
